import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import { Button, TextField } from '../../../components/ui';
import { LocalStorageService, MixpanelService, localStorageKeys } from "../../../application/services";
import { validationRules } from "../../../config/validationRules";
import { convertArabic2EnNumbers } from '../../../helpers'
const HOME_MIN_VALUE = validationRules.homeValueMin;
const HOME_MAX_VALUE = validationRules.homeValueMax;

export function HomeValue(props) {
    const { t } = useTranslation();
    const [homeValue, setHomeValue] = useState(LocalStorageService.get(localStorageKeys.homeValue) || '')
    const [error, setError] = useState(undefined)
    const replaceNonNumeric = (numStr) => {
        return String(numStr).replace(/[^0-9\u0660-\u0669]/g, '')
    }
    const commarize = (numStr) => {
        return replaceNonNumeric(numStr).replace(/.(?=(...)*...$)/g, '$&,')
    }
    const handleChange = (e) => {
        const value = e.target.value
        var priceValue = commarize(value)
        setHomeValue(priceValue)
        const homeValueToNumber = priceValue.replace(/,/g, "")
        if (isNaN(Number(convertArabic2EnNumbers(homeValueToNumber)))) {
            setError({ ...error, price_invalid: t("validation_home_is_required_message") })
        }
        else if (convertArabic2EnNumbers(homeValueToNumber) < HOME_MIN_VALUE) {
            setError({ ...error, price_invalid: t("validation_home_minimum_length_message") })
        }
        else if (convertArabic2EnNumbers(homeValueToNumber) > HOME_MAX_VALUE) {

            setError({ ...error, price_invalid: t("validation_home_maximum_length_message") })

        }
        else if (!convertArabic2EnNumbers(homeValueToNumber) > 0) {

            setError({ ...error, price_invalid: t("validation_home_value_message") })
        }
        else {
            setError(undefined)
        }
    }
    const handleNextStep = (e) => {
        e.preventDefault()
        if (!error) {
            homeValue && props.handleClickNext()
            LocalStorageService.set(localStorageKeys.homeValue, homeValue);
            MixpanelService.getInstance().HomeValueFieldClickNext({ value: homeValue })
        }
    }
    return (
        <div>
            <div className="heading mt-45">
                <p>{t("can_you_tell_me")} </p>
                <h3>{t("home_value_label")}</h3>
            </div>

            <div className="mt-30">
                <form onSubmit={handleNextStep} autoComplete="off" >
                    <TextField id="homeValue"
                        placeholder={t("home_value_placeholder")}
                        value={homeValue}
                        onChange={handleChange}
                        error={error && error.price_invalid ? true : false}
                        helperText={error && error.price_invalid}
                        name="homeValue"
                        onFocus={() => MixpanelService.getInstance().clickHomeValueField()}
                    />
                    <div className="btn-wrapper">
                        <Button
                            className={`btn ${!homeValue || error ? "disabled" : "active"}`}
                            title={t("next")}
                            type="submit"
                        />
                    </div>
                </form>
            </div>
        </div>
    )
}
